import React from 'react';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup'; // import { Debug } from '../../Molecules/Forms/Debug';

import { Button, Grid, SubmitButton, Typography, makeStyles } from '../../';
import { Link } from 'react-router-dom';
var loginSchema = Yup.object().shape({
  email: Yup.string().email('Debes introducir un email válido').required('Campo obligatorio'),
  password: Yup.string().required('Campo obligatorio').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_\-!?;.,:*[\]{}()@%&/"\\<>|'~`]).{8,}$/, 'Debe contener 8 caracteres, una mayúscula, minúscula, número y carácter especial')
});
var newPwdRequiredChangeSchema = Yup.object().shape({
  password: Yup.string().required('Campo obligatorio').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_\-!?;.,:*[\]{}()@%&/"\\<>|'~`]).{8,}$/, 'Debe contener 8 caracteres, una mayúscula, minúscula, número y carácter especial'),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden')
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    form: {
      display: 'flex'
    },
    actions: {
      display: 'flex',
      padding: '30px'
    },
    flex: {
      display: 'flex'
    },
    error: {
      padding: '30px',
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary,
      borderRadius: '8px'
    },
    subtitle: {
      marginTop: '8px',
      color: '#fff'
    }
  };
});

var LoginContent = function LoginContent(props) {
  var contentLogin, initialValues, schema; // Initial Values

  var loginInitialValues = {
    email: props.email || '',
    password: ''
  };
  var newPwdRequiredChangeInitialValues = {
    password: '',
    passwordConfirmation: ''
  };

  var getDefault = function getDefault(text, isValid, isSubmitting) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12
    }, text && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.error
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, text)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.root
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "email",
      fullWidth: true,
      label: "Email",
      component: TextField,
      margin: "normal",
      variant: "outlined",
      autoComplete: "" //disabled={mode === 'view'}

    }), /*#__PURE__*/React.createElement(Field, {
      name: "password",
      fullWidth: true,
      label: "Contrase\xF1a",
      component: TextField,
      type: "password",
      margin: "normal",
      variant: "outlined" //disabled={mode === 'view'}

    }))), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      color: "primary",
      variant: "contained",
      disabled: !isValid || isSubmitting,
      component: SubmitButton,
      type: "submit"
    }, "Iniciar sesi\xF3n"), /*#__PURE__*/React.createElement(Link, {
      to: "/password-reset",
      style: {
        textDecoration: 'none'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      align: "right",
      variant: "subtitle2",
      className: classes.subtitle
    }, "\xBFHas olvidado la contrase\xF1a?"))));
  };

  var getContent = function getContent(values, isValid, isSubmitting, variant) {
    switch (variant) {
      case 'NEW_PASSWORD_REQUIRED':
        contentLogin = /*#__PURE__*/React.createElement(Grid, {
          container: true
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.root
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12
        }, /*#__PURE__*/React.createElement(Field, {
          name: "password",
          type: "password",
          fullWidth: true,
          label: "Nueva Contrase\xF1a",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          autoComplete: "" //disabled={mode === 'view'}

        }), /*#__PURE__*/React.createElement(Field, {
          name: "passwordConfirmation",
          fullWidth: true,
          label: "Repite la contrase\xF1a",
          component: TextField,
          type: "password",
          margin: "normal",
          variant: "outlined" //disabled={mode === 'view'}

        }))), /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          color: "primary",
          variant: "contained",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, "Cambiar contrase\xF1a"));
        break;

      case 'UserNotConfirmedException':
        contentLogin = getDefault('Usuario no confirmado. Revisa tu email', isValid, isSubmitting);
        break;

      case 'NotAuthorizedException':
        contentLogin = getDefault('Usuario no autorizado. Revisa tu email', isValid, isSubmitting);
        break;

      case 'UserNotFoundException':
        contentLogin = getDefault('Usuario no encontrado.', isValid, isSubmitting);
        break;

      default:
        contentLogin = getDefault('', isValid, isSubmitting);
        break;
    }

    return contentLogin;
  };

  switch (props.variant) {
    case 'NEW_PASSWORD_REQUIRED':
      initialValues = newPwdRequiredChangeInitialValues;
      schema = newPwdRequiredChangeSchema;
      break;

    case 'UserNotConfirmedException':
      initialValues = loginInitialValues;
      schema = loginSchema;
      break;

    case 'NotAuthorizedException':
      initialValues = loginInitialValues;
      schema = loginSchema;
      break;

    case 'UserNotFoundException':
      initialValues = loginInitialValues;
      schema = loginSchema;
      break;

    default:
      initialValues = loginInitialValues;
      schema = loginSchema;
      break;
  }

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      resetForm({
        email: values.email,
        password: ''
      });

      if (props.variant === 'NEW_PASSWORD_REQUIRED') {
        props.newPwdRequired(values);
      } else {
        props.login(values);
      }
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          setFieldValue = _ref2.setFieldValue,
          handleBlur = _ref2.handleBlur,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        className: classes.form
      }, getContent(values, isValid, isSubmitting, props.variant));
    }
  });
};

export { LoginContent };